/**
 * Shared "your file is too big" toast helper.
 *
 * Surfaces an actionable sonner error toast that includes:
 *   - The actual file size (in MB, rounded to 1dp).
 *   - A one-click action button that opens iLovePDF's free compressor
 *     (the tool most founders end up Googling anyway, so we save them the
 *     hop and stop them bouncing out of onboarding / funder setup).
 *
 * Usage:
 *   import { showOversizedFileToast } from "../lib/uploadToast";
 *   if (file.size > capMb * 1024 * 1024) {
 *     showOversizedFileToast(file, capMb);
 *     return;
 *   }
 */
import { toast } from "sonner";

export function showOversizedFileToast(file, capMb, opts = {}) {
  if (!file) return;
  const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
  const label = opts.label || file.name;
  toast.error(
    `${label} is ${sizeMb} MB — over our ${capMb} MB limit.`,
    {
      description:
        opts.description ||
        "Most PDFs shrink by 60-80% with one click. We recommend iLovePDF (free).",
      action: {
        label: "Compress now",
        onClick: () =>
          window.open(
            "https://www.ilovepdf.com/compress_pdf",
            "_blank",
            "noopener,noreferrer"
          ),
      },
      duration: 12000,
    }
  );
}
